<template>
  <div class="wall flex-between">
    <div class="p-20">
      <div class="color-sliver fs-12 title_text">待发货</div>
      <router-link to="/order">
        <div class="fs-20 mt-15 flex-center-center">{{ unsend }}</div>
      </router-link>
    </div>
    <div class="p-20">
      <div class="color-sliver fs-12 title_text">待售后</div>
      <router-link to="/order">
        <div class="fs-20 mt-15 flex-center-center">0</div>
      </router-link>
    </div>
    <div class="p-20">
      <div class="color-sliver fs-12 title_text">今日订单</div>
      <router-link to="/order">
        <div class="fs-20 mt-15 flex-center-center">-</div>
      </router-link>
    </div>
    <div class="p-20">
      <div class="color-sliver fs-12 title_text">今日销售额</div>
      <router-link to="/order">
        <div class="fs-20 mt-15 text-price flex-center-center">-</div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import { getOrderList } from '@/api/order.js';
  export default {
    data () {
      return {
        unsend: 0,
      }
    },
    created() {
      if (this.$store.getters.hasPermission('view_orders')) {
        getOrderList({
          status: 'unsend',
          offset: 0,
          limit: 1
        }).then(res => {
          this.unsend = res.count || 0;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>